/**
 * Build Ads Assistant platform dropdown options from `organizations.sales_daily_checklist_config`
 * (v2 `ads.platform_entries`) plus Facebook / Google defaults.
 */
export type AdsPlatformSelectOption = { key: string; label: string };

const KEY_RE = /^[a-z][a-z0-9_]{0,32}$/;

export function platformOptionsFromOrgChecklistConfig(raw: unknown): AdsPlatformSelectOption[] {
  const labels = new Map<string, string>([
    ["facebook", "Facebook"],
    ["google", "Google"],
  ]);

  if (raw && typeof raw === "object" && !Array.isArray(raw)) {
    const ads = (raw as Record<string, unknown>).ads as Record<string, unknown> | undefined;
    const entries = ads?.platform_entries;
    if (Array.isArray(entries)) {
      for (const e of entries) {
        if (!e || typeof e !== "object") continue;
        const r = e as Record<string, unknown>;
        const key = typeof r.key === "string" ? r.key.trim().toLowerCase() : "";
        if (!KEY_RE.test(key)) continue;
        const label = typeof r.label === "string" && r.label.trim() ? r.label.trim() : key;
        labels.set(key, label);
      }
    }
  }

  const keys = [...labels.keys()].sort((a, b) => {
    const order = (k: string) => (k === "facebook" ? 0 : k === "google" ? 1 : 2);
    const d = order(a) - order(b);
    if (d !== 0) return d;
    return a.localeCompare(b);
  });

  return keys.map((key) => ({ key, label: labels.get(key) ?? key }));
}
